<script>
export default {
    data() {
        return {
            tableau: [
                `Koffiezetapparaat <span>capsule-compatibel</span> `, "Koptelefoon JBL", "stofzuiger 2 in 1", "SmartWatch GTS4" , "Airfryer",
            ],
        }
    }
}
</script>

<template>
    <div class="">
        <div class="table-wrapper">
            <div class="table-title-wrapper">
                <p class="table-title">Een paar voorbeelden van cadeau’s</p>
<!--                <p class="table-price">Prijs</p>-->
            </div>
            <div class="table-item" v-for="elem in tableau">
                <p class="table-item__gift" v-html="elem"></p>
                <p class="table-item__price">GRATIS</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
